<template>
  <div>
    <section class="process-desc">
      <div v-for="(item,index) in steps"
            :key="item.id"
            class="process-desc-item" 
            :class="{'process-desc-item-arrow':index!== steps.length-1, 
            'process-desc-item-slot': index!==0}"
>
        <div class="process-info-wrapper">
          <span class="process-index">{{ item.index }}</span>
          <span style="font-size: 16px; color: #FFFFFF;" class="ml-10">{{ item.text }}</span>
        </div>
      </div>
    </section>
    <ux-divider />
  </div>
</template>
<script>
import { steps } from './config';
export default {
  data() {
    return {
      steps: steps
    }
  }
}
</script>
<style scoped>
.process-desc-item {
  width: 155px;
  height: 50px;
  color: #fff;
  background: #4285F4;
  text-align: center;
  line-height: 50px;
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.process-desc-item:last-child {
  margin-right: 0;
}
.process-desc-item-arrow:after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  right: -6px;
  background: #4285F4;
  top: 19px;
  z-index: 1;
}
.process-desc-item-slot:before {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  left: -6px;
  background: #fff;
  top: 19px;
}
.process-index {
  font-size: 10px;
  color: #428DF4;
  display: inline-block;
  height: 16px;
  width: 16px;
  background: #fff;
  line-height: 16px;
  border-radius: 50%;

}
.process-info-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>